/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-01 13:52:54
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-02-28 10:02:13
 */
const parentRouter = [
  {
    label: '供应商寻源管理',
    path: ''
  }
]
const routes = [
  // {
  //   path: '',
  //   name: 'portrait',
  //   meta: {
  //     icon: '.icon-a-Property1gongyingshangyaoqing-1',
  //     title: '寻源规则及报告模板维护',
  //     keepAlive: true,
  //     parentTitle: parentRouter
  //   },
  // },
  {
    path: '/sourcing/rulerAndTemplate/ruler',
    name: 'ruler',
    meta: {
      icon: '.icon-a-Property1gongyingshangyaoqing-1',
      title: '寻源规则维护',
      keepAlive: true,
      // parentTitle: parentRouter,
      parentTitle: [...parentRouter, { label: '寻源规则及报告模板维护', path: '' }]
    },
    component: () => import('@main/modules/sourcingManage/views/Ruler.vue')
  },
  {
    path: '/sourcing/rulerAndTemplate/template',
    name: 'template',
    meta: {
      icon: '.icon-a-Property1gongyingshangyaoqing-1',
      title: '寻源报告模板维护',
      keepAlive: true,
      // parentTitle: parentRouter,
      parentTitle: [...parentRouter, { label: '寻源规则及报告模板维护', path: '' }]
    },
    component: () => import('@main/modules/sourcingManage/views/Template.vue')
  },
  {
    path: '/sourcing/rulerAndTemplate/template/sourceTemplateEdit',
    name: 'sourceTemplateEdit',
    meta: {
      icon: '.icon-a-Property1gongyingshangyaoqing-1',
      title: '寻源报告模板编辑',
      keepAlive: false,
      // parentTitle: parentRouter,
      parentTitle: [...parentRouter, { label: '寻源报告模板维护', path: '/sourcing/rulerAndTemplate/template' }]
    },
    component: () => import('@main/modules/sourcingManage/components/sourceTemplateEdit.vue')
  },
  {
    path: '/sourcing/rulerAndTemplate/template/sourceTemplatePreview',
    name: 'sourceTemplatePreview',
    meta: {
      icon: '.icon-a-Property1gongyingshangyaoqing-1',
      title: '寻源报告模板预览',
      keepAlive: false,
      parentTitle: [...parentRouter, { label: '寻源报告模板维护', path: '/sourcing/rulerAndTemplate/template' }]
    },
    component: () => import('@main/modules/sourcingManage/components/sourceTemplatePreview.vue')
  },
  {
    path: '/sourcing/receivingAndFeedback',
    name: 'receivingAndFeedback',
    meta: {
      icon: 'icon-a-Property1gongyingshangzonglan',
      title: '寻源需求接收及反馈',
      keepAlive: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/sourcingManage/views/ReceivingAndFeedback.vue')
  },
  {
    path: '/sourcing/receivingAndFeedback/feedbackRecord',
    name: 'feedbackRecord',
    meta: {
      icon: '.icon-a-Property1gongyingshangyaoqing-1',
      title: '反馈记录',
      keepAlive: false,
      parentTitle: [...parentRouter, { label: '寻源需求接收及反馈', path: '/sourcing/receivingAndFeedback' }]
    },
    component: () => import('@main/modules/sourcingManage/components/feedbackRecord.vue')
  },
  {
    path: '/sourcing/addDemand',
    name: 'addDemand',
    meta: {
      icon: '.icon-a-Property1gongyingshangyaoqing-1',
      title: '新增寻源需求',
      keepAlive: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/sourcingManage/views/AddDemand.vue')
  },
  {
    path: '/sourcing/addDemand/addPage',
    name: 'addPage',
    meta: {
      icon: '.icon-a-Property1gongyingshangyaoqing-1',
      title: '新增',
      keepAlive: false,
      parentTitle: [...parentRouter, { label: '新增寻源需求', path: '/sourcing/addDemand' }]
    },
    component: () => import('@main/modules/sourcingManage/components/addDemandPage.vue')
  },
  {
    path: '/sourcing/retrieval',
    name: 'retrieval',
    meta: {
      icon: 'icon-a-Property1gongyingshangzonglan',
      title: '供应商寻源检索',
      keepAlive: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/sourcingManage/views/Retrieval.vue')
  },
  {
    path: '/sourcing/retrieval/generateSourceReport',
    name: 'retrieval',
    meta: {
      icon: 'icon-a-Property1gongyingshangzonglan',
      title: '供应商寻源报告',
      keepAlive: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/sourcingManage/components/generateSourceReport.vue')
  },
  {
    path: '/sourcing/statistics',
    name: 'statistics',
    meta: {
      icon: '.icon-a-Property1gongyingshangyaoqing-1',
      title: '寻源记录统计',
      keepAlive: true,
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/sourcingManage/views/Statistics.vue')
  },
]
export default routes
